import React from 'react'
import { Form } from 'react-bootstrap'
import { Project } from '../../../types/models/project'

interface TargetProjectSelectorProps {
  mode: 'existing' | 'new'
  setMode: (m: 'existing' | 'new') => void
  classificationProjects: Project[]
  targetProjectId: string
  setTargetProjectId: (id: string) => void
  newProjectName: string
  setNewProjectName: (name: string) => void
}

const TargetProjectSelector: React.FC<TargetProjectSelectorProps> = ({
  mode,
  setMode,
  classificationProjects,
  targetProjectId,
  setTargetProjectId,
  newProjectName,
  setNewProjectName,
}) => {
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="text-light">Target</Form.Label>
        <div className="d-flex gap-2">
          <Form.Check
            type="radio"
            label={<span className="text-light">Existing project</span>}
            name="mode"
            checked={mode === 'existing'}
            onChange={() => setMode('existing')}
          />
          <Form.Check
            type="radio"
            label={<span className="text-light">Create new</span>}
            name="mode"
            checked={mode === 'new'}
            onChange={() => setMode('new')}
          />
        </div>
      </Form.Group>
      {mode === 'existing' ? (
        <Form.Group className="mb-3">
          <Form.Label className="text-light">Classification project</Form.Label>
          <Form.Select
            className="bg-dark text-light border-secondary"
            value={targetProjectId}
            onChange={(e) => setTargetProjectId(e.target.value)}
          >
            {classificationProjects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
            {classificationProjects.length === 0 && (
              <option value="">No classification projects</option>
            )}
          </Form.Select>
        </Form.Group>
      ) : (
        <Form.Group className="mb-3">
          <Form.Label className="text-light">New project name</Form.Label>
          <Form.Control
            className="bg-dark text-light border-secondary"
            type="text"
            placeholder="Enter project name"
            value={newProjectName}
            onChange={(e) => setNewProjectName(e.target.value)}
          />
        </Form.Group>
      )}
    </>
  )
}

export default TargetProjectSelector
